/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_None_UpcomingInputs */



/**
* | output |
* | --- |
* | "No upcoming tournaments." |
*
* @param {Tournaments_None_UpcomingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_none_upcoming = /** @type {((inputs?: Tournaments_None_UpcomingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_None_UpcomingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tournoi à venir.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay torneos próximos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum torneio próximo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun torneo in programma.")
	return /** @type {LocalizedString} */ ("No upcoming tournaments.")
});